import SearchItem from './search_item.js';

export default Vue.extend({
  components: {
    'search-item': SearchItem,
  },

  props: {
    searchFactors: {
      type: Array,
      default() {
        return [];
      },
    },
    searchGroupIndex: {
      type: Number,
      default: 1,
    },
    popoverFieldOptions: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      updatedSearchFactors: this.searchFactors,
    };
  },

  template: `
    <div v-if="updatedSearchFactors.length">
      <div class="form-partition-text" v-if="searchGroupIndex != 0">或搜索</div>
      <div class="form-conditions-content">
        <div class="form-conditions-content-title justify-between">
          <span>条件组{{ searchGroupIndex + 1 }}</span>
          <div class="btn icon-btn" @click="deleteSearchGroup">
            <i class="slp-times"></i>
          </div>
        </div>
        <div class="form-field mb-6"">
          <div class="form-field-head">
            <div class="form-field-title">搜索字段名：</div>
          </div>
          <search-item v-for='search_factor in updatedSearchFactors'
                          :key='search_factor.id'
                          :currentSearchFactor='search_factor'
                          :popoverFieldOptions='popoverFieldOptions'
                          @toggleResetSearchFactorExactMatch='resetSearchFactorExactMatch'
                          @deleteSearchFactor='deleteSearchFactorFunc'
                          @addSearchFactor='addSearchFactorFunc'/>
        </div>
      </div>
    </div>
  `,

  methods: {
    resetSearchFactorExactMatch(searchFactor) {
      searchFactor.full_match = !searchFactor.full_match;
    },

    deleteSearchFactorFunc(searchFactor) {
      this.updatedSearchFactors = _.without(this.updatedSearchFactors, searchFactor);
    },

    addSearchFactorFunc(searchFactor) {
      this.updatedSearchFactors.push(searchFactor);
    },

    deleteSearchGroup() {
      this.updatedSearchFactors = [];
    },

    getValue() {
      return this.updatedSearchFactors;
    },
  },
});
